
import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Box } from "@mui/material";
import { debounce } from "lodash";

const StyledRating = styled(Rating)({
    "& .MuiRating-icon": {
        transition: "color 0.3s ease, transform 0.3s ease",
    },
    "& .MuiRating-iconFilled": {
        color: "#1E90FF",
    },
    "& .MuiRating-iconHover": {
        transform: "scale(1.2)",
    },
    "& .MuiRating-iconFilled.MuiRating-iconHover, & .MuiRating-iconFilled.MuiRating-iconHover ~ .MuiRating-iconFilled": {
       color: "#1E90FF",
    },
    "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
        color: "#B0C4DE",
    },
    "& .MuiRating-pristine": {
        outline: "transparent",
        position: "unset",
    },
});

function RadioGroupRating({ rating, setSelectedRating, localized }) {
    return (
        <Box>
            <StyledRating
                name="customized-rating"
                precision={1}
                defaultValue={rating}
                onChange={debounce(
                    (_event, newValue) => setSelectedRating(newValue),
                    450
                )}
                icon={<StarIcon sx={{ fontSize: "6rem" }} />} 
                emptyIcon={<StarBorderIcon sx={{ fontSize: "6rem" }} />}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "3rem",
                    padding: "2rem 0",
                }}
            />

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <span className="fs-3 fw-bold">{localized.Unsatisfied}</span>
                <span className="fs-3 fw-bold">{localized.HighlySatisfied}</span>
            </Box>
        </Box>
    );
}

RadioGroupRating.propTypes = {
    rating: PropTypes.number.isRequired,
    setSelectedRating: PropTypes.func.isRequired,
    localized: PropTypes.object.isRequired,
};

export default RadioGroupRating;
